var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon32PxShoppingBagOutlineAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9349 25.9507C26.9641 26.2097 26.9379 26.4719 26.8583 26.7202C26.7787 26.9684 26.6476 27.1969 26.4733 27.3908C26.2987 27.5843 26.0849 27.7388 25.8463 27.8437C25.6076 27.9487 25.3493 28.0021 25.0886 28.0001H7.06876C6.80801 28.0021 6.5498 27.9487 6.31113 27.8437C6.07246 27.7388 5.85873 27.5843 5.68404 27.3908C5.5098 27.1969 5.3786 26.9684 5.29905 26.7202C5.21949 26.4719 5.19338 26.2097 5.22246 25.9507L6.8472 11.3835H25.3102L26.9349 25.9507Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4629 11.3851V8.6157C11.4629 7.39154 11.9492 6.21751 12.8148 5.3519C13.6804 4.4863 14.8545 4 16.0786 4C17.3028 4 18.4768 4.4863 19.3425 5.3519C20.2081 6.21751 20.6944 7.39154 20.6944 8.6157V11.3851",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0502 19.5115H12.0234",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0352 15.4983V23.525",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32PxShoppingBagOutlineAdd);
export default __webpack_public_path__ + "static/media/icon_32px_shopping-bag_outline_add.49030e64e25e4923b76470edad366e97.svg";
export { ForwardRef as ReactComponent };